import styled from 'styled-components';

export const DurationInputGroup = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing[3]};
  align-items: center;
`;

export const DurationField = styled.div`
  flex: 1;
`;
